  <template>
    <section>
      <div class="mt-8 flex items-center">
          <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 mr-2 card">
            <h3
              class="mb-1 text-gray-800 text-center text-3xl font-medium"
            >
              {{ usersCourses.length }}
            </h3>
            <p class="text-sm text-center text-gray-600">
              Erstellte Contentmodule
            </p>
          </div>
          <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 ml-2 card">
            <h3
              class="mb-1 text-gray-800 text-center text-3xl font-medium"
            >
              14
            </h3>
            <p class="text-sm text-center text-gray-600">
              Geprüfte Lehrmaterialien
            </p>
          </div>
        </div>
        <div class="mt-4 flex items-center">
          <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 mr-2 card">
            <h3
              class="mb-1 text-gray-800 text-center text-3xl font-medium"
            >
              08
            </h3>
            <p class="text-sm text-center text-gray-600">
              Contentmodule in Prüfung
            </p>
          </div>
          <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 ml-2 card">
            <h3
              class="mb-1 text-gray-800 text-center text-3xl font-medium"
            >
              22
            </h3>
            <p class="text-sm text-center text-gray-600">
              Studenten
            </p>
          </div>
        </div>
        <br>
<!--          <div>
          <section>
            <template>
                <grid-layout 
                :layout.sync="layout"
                :col-num="12"
                :row-height="30"
                :is-draggable="draggable"
                :is-resizable="false"
                :vertical-compact="true"
                :use-css-transforms="true"
                >
                    <grid-item v-for="item in layout" 
                    :key="item.i"
                    :static="item.static"
                    :x="item.x"
                    :y="item.y"
                    :w="item.w"
                    :h="item.h"
                    :i="item.i"
                    >
                    <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 ml-2 card">
                      <h3
                        class="mb-1 text-gray-800 text-center text-3xl font-medium"
                      >
                      {{itemCount(item)}}
                      </h3>
                      <p class="text-sm text-center text-gray-600">
                        {{itemTitle(item)}}
                      </p>
                    </div>
                    </grid-item>
                </grid-layout>
            </template>
          </section>
        </div> -->
      </section>
    </template>
  <script>
    import gql from "graphql-tag";
    import { mapState } from "vuex";
    // import { GridLayout, GridItem } from 'vue-grid-layout';

    export default {
        name: 'KeyPerformance',
    data: function () {
    return {
      layout: [
                {"x":0,"y":0,"w":50,"h":4,"i":"Erstellte Contentmodule","count":4, static: true},
                {"x":2,"y":0,"w":50,"h":4,"i":"Geprüfte Lehrmaterialien","count":3, static: false},
                {"x":4,"y":0,"w":50,"h":4,"i":"Contentmodule in Prüfung","count":2, static: false},
                {"x":6,"y":0,"w":50,"h":4,"i":"Studenten","count":1, static: false},
            ],
            draggable: true,
            resizable: true,
            index: 0
        }
      },
        components: {
            //  GridLayout,
            //  GridItem
        },
        apollo: {
          courseCategories: {
            query: gql`
              query {
                courseCategories {
                  id
                  name
                  courses {
                    id
                    name
                    description
                    isPublic
                    duration
                    skill {
                      name
                    }
                    instructor {
                      firstName
                      lastName
                    }
                    sections {
                      name
                      description
                      modules {
                        name
                        description
                      }
                    }
                  }
                }
              }
            `,
          },
        },
        computed: {
              ...mapState({
            courseCategories: "courseCategories",
            usersCourses: "usersCourses",
          }),
        },
        methods: {
        itemTitle(item) {
            let result = item.i;
            if (item.static) {
                result += " - Static";
            }
            return result;
        },
        itemCount(item) {
            let result = item.count;
            return result;
        }
    }
    }
</script>
<style scoped>
.vue-grid-layout {
    background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: #ccc;
    border: 1px solid black;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
</style>